import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApprovedByListComponent } from './approved-by-list/approved-by-list.component';
import { ApprovedByCreateComponent } from './approved-by-create/approved-by-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: ApprovedByListComponent,
        data: {
          title: "ApprovedBy List",
          breadcrumb: "ApprovedBy List"
        }
      },
      {
        path: 'create',
        component: ApprovedByCreateComponent,
        data: {
          title: "Create ApprovedBy",
          breadcrumb: "Create ApprovedBy"
        }
      },
      {
        path: 'edit/:id',
        component: ApprovedByCreateComponent,
        data: {
          title: "Edit ApprovedBy",
          breadcrumb: "Edit ApprovedBy"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ApprovedByRoutingModule { }
